import usCities from 'data/usCities';

export const usStateCitiesOptions = usCities.map(({ cityName, displayName, code, country }) => {
  return { disabled: true, label: displayName, value: cityName, country, region: code };
});
